import React from 'react';

const Header = () => {
  return <header className="desktop-header"/>
}

export default Header;
